// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3h73M","inner":"Form_inner__2k5lk","range":"Form_range__1R9E5","name":"Form_name__2A0GC","actions":"Form_actions__1D1gn"};